// @ts-nocheck
import React, { ChangeEvent, useCallback } from 'react';
import { Naskor } from "../../../../../../js/components/naskor";
import * as InterfaceCollection from "../../InterfaceCollection";
import { formatCurrencyEur } from '../../../../../Helper/formatter';

export default function ProductLabelService({
  basket,
  reloadBasket,
}: {
  basket: InterfaceCollection.VtsBasket;
  reloadBasket: CallableFunction;
}) {
  const handleProductLabelServiceClick = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked ? '1' : '0';
    Naskor.fetchJson('/api/onlineshop/vts-release-basket/set-label-service/' + value);
    reloadBasket();
  }, [reloadBasket]);

  return (
    <div className="row margin-bottom">
      <div className="col-xs-12">
        <div className="basket-footer-information">
          <label>
            <input
              type="checkbox"
              defaultChecked={basket.is_product_label_service}
              onChange={handleProductLabelServiceClick}
            />
            (
            {formatCurrencyEur(
              basket.total_position_label_price_excl_vat ?? 0
            )}
            )
          </label>
        </div>
      </div>
    </div>
  );
}
